import Button from "../../components/global/Button";
import AuthLayout from "../../components/auth/AuthLayout";
import PageTitle from "../../components/auth/PageTitle";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";
import TermsAndConditions from "../../components/auth/TermsAndConditions";
import {
  auth,
  googleProvider,
  signInWithPopup,
} from "../../notification/firebase";
import { GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ImgIcon, toastMessage } from "../../utils/utils";
import { useGetAllClubsByNameQuery } from "../../lib/redux/services/sections/Clubs";

import { useRegisterWithGoogleMutation } from "../../lib/redux/services/sections/Auth";
import { useNavigate } from "react-router-dom";
import googleIcon from "../../assets/icons/Google.svg";
import appleIcon from "../../assets/icons/Apple.svg";
const WelcomeScreen = () => {
  const navigate = useNavigate();
  const { Auth }: DictionaryType = useGetDictionary();
  const [token, setToken] = useState<string | null>(
    localStorage.getItem("token")
  );
  const [registerWithGoogle] = useRegisterWithGoogleMutation();
  const { data: clubs, refetch } = useGetAllClubsByNameQuery(
    {},
    {
      skip: !token,
    }
  );

  localStorage.setItem("theme", "light");

  const [user, setUser] = useState<any>(null);

  const handleAppleLoginWithPopup = async () => {
    try {
      const provider = new OAuthProvider("apple.com");
      const result = await signInWithPopup(auth, provider);

      const idToken = await result.user.getIdToken();

      const appleData = {
        email: result.user.email,
        name: result.user.displayName || result.user.email,
        token: idToken,
      };

      try {
        const data = await toast.promise(
          registerWithGoogle(appleData).unwrap(),
          toastMessage()
        );

        localStorage.setItem("token", data.access_token);
        localStorage.setItem("user", JSON.stringify(data.user));
        localStorage.setItem("mocion-admin-id", data.user.uid);

        if (data.first_login) {
          navigate(`/auth/register`, { state: data });
        } else {
          setToken(data.access_token);
        }
      } catch (error) {
        console.error("Login error:", error);
      }

      const credential = OAuthProvider.credentialFromResult(result);
      if (credential) {
      }
    } catch (error) {
      console.error("Apple Login Error:", error);
    }
  };

  const handleGoogleLoginWithPopup = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const idToken = await result.user.getIdToken();

      const firbaseData = {
        email: result.user.email,
        name: result.user.displayName,
        token: idToken,
      };
      console.log("from welcome screen");

      setUser(result.user);
      try {
        const data = await toast.promise(
          registerWithGoogle(firbaseData).unwrap(),
          toastMessage()
        );
        localStorage.setItem("token", data.access_token);
        localStorage.setItem("user", JSON.stringify(data.user));
        localStorage.setItem("mocion-admin-id", data.user.uid);
        if (data.first_login) {
          navigate(`/auth/register`, { state: data });
        } else {
          setToken(data.access_token);
        }
      } catch (error) {
        console.error("Login error:", error);
      }

      const credential = GoogleAuthProvider.credentialFromResult(result);
      if (credential) {
      }
    } catch (error) {
      console.error("Login Error:", error);
    }
  };

  useEffect(() => {
    if (token) {
      refetch();
    }
  }, [token, refetch, clubs]);

  if (clubs) {
    localStorage.setItem(
      "clubId",
      JSON.stringify(clubs?.data.length > 0 ? clubs.data[0].id : "")
    );
    localStorage.setItem("clubs", JSON.stringify(clubs?.data));
    navigate("/club-settings/organization");
  }

  // useEffect(() => {
  //   const checkRedirectResult = async () => {
  //     try {
  //       const result = await getRedirectResult(auth);
  //       if (result && result.user) {
  //         setUser(result.user);
  //

  //         const idToken = await result.user.getIdToken();
  //
  //         localStorage.setItem("google-id-token", idToken);

  //         const credential = GoogleAuthProvider.credentialFromResult(result);
  //         if (credential) {
  //
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Redirect Login Error:", error);
  //     }
  //   };

  //   checkRedirectResult();

  //   const unsubscribe = onAuthStateChanged(auth, (user) => {
  //     if (user) {
  //
  //       setUser(user);
  //     } else {
  //       setUser(null);
  //     }
  //   });

  //   return () => unsubscribe();
  // }, []);

  return (
    <AuthLayout>
      <div className="text-center mt-4 flex flex-col gap-4">
        <div className="flex flex-col justify-center items-center gap-5">
          <PageTitle title={Auth?.welcome_page?.welcome} />
          <p className="text-lg font-normal break-words leading-relaxed whitespace-pre-wrap text-[#1E1850] mt-2">
            {Auth?.welcome_page?.welcome_messgae_1}
            <br />
            {Auth?.welcome_page?.welcome_messgae_2}
          </p>
        </div>

        <div className="mt-6 flex flex-col items-center justify-center gap-6 w-full">
          <Button
            customeStyle="bg-primary text-white w-full rounded-full text-lg py-4 font-bold"
            href="/auth/login"
            text={Auth?.login}
            width="max-w-[400px] w-full"
          />

          <Button
            customeStyle="bg-white text-primary dark:text-white w-full rounded-full text-lg py-4 border-primary border-2"
            href="/auth/register"
            text={Auth?.welcome_page?.create_account}
            width="max-w-[400px] w-full"
          />

          <Button
            customeStyle="bg-white text-primary dark:text-white w-full rounded-full text-lg py-4 flex flex-row gap-2 border-primary border-2  justify-center items-center "
            text={Auth?.welcome_page?.google_sign_in}
            width="max-w-[400px] w-full"
            onClick={handleGoogleLoginWithPopup}
            Icon={() => ImgIcon(googleIcon, 24, 24)}
          />

          <Button
            customeStyle="bg-white text-primary dark:text-white w-full rounded-full text-lg py-4 flex flex-row gap-2 border-primary border-2  justify-center items-center "
            text={Auth?.welcome_page?.apple_sign_in}
            width="max-w-[400px] w-full"
            onClick={handleAppleLoginWithPopup}
            Icon={() => ImgIcon(appleIcon, 24, 24)}
          />
        </div>

        <TermsAndConditions />
      </div>
    </AuthLayout>
  );
};

export default WelcomeScreen;
